import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Badge, Navigation } from '@shopify/polaris';
import { AlertCircleIcon, InventoryIcon } from '@shopify/polaris-icons';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';
import { useWarehouseLabelConfigs } from '../../labelConfig/hooks/useWarehouseLabelConfig';
import { getWarehouseSelectedLocation } from './WarehouseLocationToggle';

const WarehouseSidebar = () => {
  const location = useLocation();
  const { user } = useContext(AuthenticationContext);
  const hasAdminModule = user?.modules?.some((module) => module.value === 'warehouse' && parseInt(module.tier) > 2);

  // Same query key as the label config page, so a save there refreshes this flag too. Counts
  // server state (slug null = no group claimed it), so an unsaved move on the page does not flag.
  const { data: labelConfigsData } = useWarehouseLabelConfigs(getWarehouseSelectedLocation());
  const unassignedCount = (labelConfigsData?.data?.departments ?? []).filter((dept) => !dept.slug).length;
  // Only admins can assign departments, so only they get the flag.
  const labelConfigBadge =
    hasAdminModule && unassignedCount > 0 ? (
      <Badge tone="critical" icon={AlertCircleIcon as any}>
        {String(unassignedCount)}
      </Badge>
    ) : undefined;

  const subNavigationItems = [
    // On hold: warehouse pickup is not the default entry point.
    // { url: '/warehouse/warehouse_pickup', disabled: false, label: 'Warehouse Pickup' },
    { url: '/warehouse/receiving', disabled: false, label: 'Receiving' },
    { url: '/warehouse/warehouse_options', disabled: false, label: 'Warehouse Options' },
    { url: '/warehouse/notification_config', disabled: false, label: 'Notifications' },
    { url: '/warehouse/label_config', disabled: false, label: 'Label Configuration', badge: labelConfigBadge },
  ];

  const navigationItems = [
    {
      label: 'Warehouse',
      url: '/warehouse/receiving',
      icon: InventoryIcon as any,
      matches: true,
      subNavigationItems,
    },
  ];

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section items={navigationItems} />
    </Navigation>
  );
};

export default WarehouseSidebar;
